import { Plugin, toWidget, WidgetToolbarRepository } from 'ckeditor5';
function createPlaceholderView(modelItem, viewWriter) {
    const id = modelItem.getAttribute('id');
    const placeholderView = viewWriter.createContainerElement('span', {
        class: 'placeholder',
        'data-placeholder': id,
    });
    const innerText = viewWriter.createText(id);
    viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), innerText);
    return placeholderView;
}
/**
 * This plugin adds support for placeholders in the editor.
 * Handling the up and down casting of the placeholders.
 */
export class PlaceholderSchema extends Plugin {
    static get pluginName() {
        return 'PlaceholderFields';
    }
    static get requires() {
        return [WidgetToolbarRepository];
    }
    init() {
        this.defineSchema();
        this.defineConverters();
    }
    defineSchema() {
        const { schema } = this.editor.model;
        schema.register('placeholder', {
            inheritAllFrom: '$inlineObject',
            allowAttributes: ['id'],
        });
    }
    defineConverters() {
        const { conversion } = this.editor;
        conversion.for('upcast').elementToElement({
            view: {
                name: 'span',
                attributes: ['data-placeholder'],
            },
            model: (viewElement, { writer: modelWriter }) => {
                const id = viewElement.getAttribute('data-placeholder');
                if (!id) {
                    throw Error('No name found on placeholder');
                }
                return modelWriter.createElement('placeholder', { id });
            },
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'placeholder',
            view: (modelItem, { writer: viewWriter }) => {
                const widgetElement = createPlaceholderView(modelItem, viewWriter);
                // Set a custom property 'placeholder' to later on validate if the view element is a placeholder.
                viewWriter.setCustomProperty('placeholder', true, widgetElement);
                return toWidget(widgetElement, viewWriter, { label: 'placeholder' });
            },
        });
        conversion.for('editingDowncast').add((dispatcher) => {
            dispatcher.on('attribute:id:placeholder', (evt, data, conversionApi) => {
                const { item, attributeNewValue } = data;
                const { mapper, writer } = conversionApi;
                const viewElement = mapper.toViewElement(item);
                if (viewElement) {
                    writer.setAttribute('data-placeholder', attributeNewValue, viewElement);
                    const textNode = viewElement.getChild(0);
                    if (textNode && textNode.is('$text')) {
                        writer.remove(writer.createRangeOn(textNode));
                        writer.insert(writer.createPositionAt(viewElement, 0), writer.createText(attributeNewValue));
                    }
                }
            });
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'placeholder',
            view: (modelItem, { writer: viewWriter }) => createPlaceholderView(modelItem, viewWriter),
        });
    }
}
